import { LinkOutlined } from '@ant-design/icons'
import { Dropdown, Button, Tooltip } from 'antd'
import { useExternalLinkEditorContext } from '../../ExternalLinkEditorContext'

/** @private */
const QuickLinkDropdownButton: React.FC = () => {
  const { quickLinkOptions, disabled, add } = useExternalLinkEditorContext()
  if (!quickLinkOptions) return null
  const { quickLinks, loading } = quickLinkOptions
  if (!quickLinks?.length) return null
  return (
    <Dropdown
      disabled={disabled || loading}
      menu={{
        onClick: ({ key }) => {
          const found = quickLinks.find(({ id }) => id === key)
          if (!found) return
          const { label, href } = found
          add({ label, href })
        },
        items: quickLinks.map(({ id, label, description }) => ({
          key: id,
          label: (
            <Tooltip title={description ?? undefined} placement="right">
              {label}
            </Tooltip>
          ),
        })),
      }}
    >
      <Button type="primary" icon={<LinkOutlined />}>
        Quick Link
      </Button>
    </Dropdown>
  )
}

export default QuickLinkDropdownButton
